import  {Component} from 'react';
import axios from "axios";
import {apiConfigs } from '../configs';

const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
const token = match ? match[2] : null;
const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'bearer ' + token//window.localStorage.getItem("token")
};
class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 10000;
    }


    //Splash Page
    start = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.get( `application/start`, {
            headers
        })
            .then(response => {
               return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Login Page
    sendOTP = (mobile) =>{
       return  axios.post( 'users/send/otp', {mobile}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Verify Page
    loginWithOTP = (mobile,otp , push_id) => {
        return  axios.post( 'users/login/otp', {mobile , otp ,push_id}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Register Page
    storeCompany = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return  axios.post( 'users/companies/store', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    updateProfile = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'bearer ' + token
        }
        return  axios.post( 'users/update', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                throw error;
            });
    }
    updateCompany = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'bearer ' + token
        }
        return  axios.post( 'users/companies/update', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                throw error;
            });
    }
    usualContent = (content) => {
        return axios.get( `application/usual/` + content, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getSlideshow = (id) => {
        return axios.get( `application/slideshow/` + id, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    index = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `application/index/` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    walletTransactions = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `wallet/transactions/` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    profile = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/profile/` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    provinces = (country_id) => {
        return axios.get( `locations/provinces/` + country_id , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    cities = (province_id) => {
        return axios.get( `locations/cities/` + province_id , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getCompany = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/companies/profile`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getAddresses = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/addresses`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getPublicAddresses = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/addresses/public/addresses`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getAddress = (id) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/addresses/get/${id}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    saveAddress = (request) =>{
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return  axios.patch( 'users/addresses/save', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    deleteAddresses = (id) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/addresses/${id}/delete`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    defaultAddresses = (id,type) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return axios.get( `users/addresses/${id}/default/${type}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getStatuses = () => {

        return axios.get( `transport/requests/statuses`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    requests = (request = null) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `transport/requests/mine`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    storeRequest = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `transport/requests/store`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    consignments = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `/shop/consignments/search`  , {'mine' : 1} ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    request = (request_id) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.get( `transport/requests/profile/${request_id}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    driverPosition = (request_id) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.get( `transport/requests/position/${request_id}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    requestDocument = (request) => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        };
        return  axios.post( 'transport/requests/document', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {

                throw error;
            });
    }
    packageTypes = () => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.get( `/shop/package-types/`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    consignmentsSave = (request) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `/shop/consignments/save`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    carTypes = (request) => {
        return axios.post( `car/car-types/`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    searchNeshan = (term) => {
        const headers = {
            'api-key': 'service.WHekcyg8yUdiQQBfIeikQZxDk9XeuO0aRjI3AMvh'
        };
        return axios.get( `https://api.neshan.org/v1/search?term=${term}&lat=0&lng=0`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    searchNeshanRevers = (lat,lng) => {
        const headers = {
            'api-key': 'service.WHekcyg8yUdiQQBfIeikQZxDk9XeuO0aRjI3AMvh'
        };
        return axios.get( `https://api.neshan.org/v4/reverse?lat=${lat}&lng=${lng}`  , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    // Set Token

    setPushToken = (request ) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `users/set/firebase/token`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    callDriverPosition = (driver_id) => {

        return axios.get( `transport/call-driver-position/${driver_id}` , {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    storeRate = (request = null) => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + token
        }
        return axios.post( `transport/requests/rate`  , request ,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


}
const API = new Api();
export default API;